import { RootState } from '~/core/store/root.reducer'

export default (state: RootState) => state.featureFlags
